import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const Identities = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { Identities, defaultState };
